export default __webpack_public_path__ + "static/media/sodexo.672f041a.svg";